import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { useBreakpoint } from "@/hooks/useBreakpoint"
import { ApplyItemType } from "@/pages/website-landing/home/sections/how-to-apply/HowToApply"
import classnames from "classnames"
import { FC } from "react"
import shortConnector from "./images/apply-shortline-img.png"
import connector from "./images/connector-light-long.png"

import "./ApplyItem.less"

const { Text, Paragraph } = WebsiteTypography
type Props = {
  it: ApplyItemType
  isModal?: boolean
}
const ApplyItem: FC<Props> = ({ it, isModal = false }) => {
  const { xxl, xl, lg, md } = useBreakpoint()

  const cardStyles = classnames({
    "apply-card": true,
    "even": it?.id === "2" || it?.id === "4",
  })
  const hexBadgeStyles = classnames({
    "hex-badge": true,
    "hex-badge-first": it?.id === "1",
    "left-side": it?.id === "2" || it?.id === "3" || it?.id === "4",
    "modal": isModal,
  })
  const connectorsStyles = classnames({
    "connector": true,
    "un-even": it?.id === "3",
    "hidden": it?.id === "1",
    "modal": isModal,
  })
  return (
    <div className={cardStyles}>
      <div className={"apply-card-content"}>
        <div className={isModal ? "hex-wrapper modal" : "hex-wrapper"}>
          <div className={isModal ? "card-hexagon modal" : "card-hexagon"}>
            <div className={"image-wrapper"}>
              <img src={it?.imageUrl} alt={""} />
            </div>
          </div>

          <div className={hexBadgeStyles}>
            <div className={"hex-badge-inner"}>
              <Text weight={"w700"} size={"xs"} color={"primary"}>
                {it?.id}
              </Text>
            </div>
          </div>
          <div className={connectorsStyles}>
            <img src={xxl || xl || lg || md ? connector : shortConnector} alt={""} />
          </div>
        </div>
        <div className={"card-content"}>
          {it?.title && (
            <div className={"card-title"}>
              <Text weight={"w700"} color={"white"} size={!isModal ? "lg" : "md"}>
                {it?.title}
              </Text>
            </div>
          )}

          {it?.description && (
            <Paragraph color={"website-secondary"} centered size={!isModal ? "md" : "sm"} className={"card-text"}>
              {it?.description}
            </Paragraph>
          )}

          {it?.descriptionAdditional && (
            <Paragraph color={"orange"} centered size={!isModal ? "md" : "sm"} className={"card-text"}>
              {it?.description}
            </Paragraph>
          )}
        </div>
      </div>
    </div>
  )
}

export default ApplyItem
